module.exports = __webpack_public_path__ + "static/gps_map1-cff59d1032a2abc912f24325951f1932.png";